<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 30em !important;">
                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/parrot.svg" style="height: 10rem !important" />
                <div class="mt-5" style="font-size: 16px">
                    <div class="mb-4" style="font-size: 20px; color: #00448b">Approve Campaign</div>
                    Do you want to Approve this Campaign?
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-no-button mr-4 px-4" @click="hideSelf">No</button>
                    <button class="btn new-yes-button ml-4 px-4" @click="confirmDelete">Yes</button>
                </div>
                <div v-else class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn btn-des-small mr-4 px-4" style="background: transparent; color: #0d5be6; border: 1px solid transparent; width: 4em" disabled>No</button>
                    <button class="btn btn-des-small ml-4 px-4" style="background: #005dae;position: relative; color: #fff; border: 1px solid transparent; width: 4em" disabled>Yes
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>   
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    props: ["modal_name"],
    data(){
        return{
            disableButtonAndDisplayLoader: false,
            reason: ''
        }
    },
    components: {
        HollowDotsSpinner,
    },
    methods: {
        hideSelf() {
            this.$emit("cancelApproval");
            this.$modal.hide(this.modal_name);
        },
        confirmDelete() {
            this.disableButtonAndDisplayLoader = true;
            this.$emit("ApproveActivity",this.reason);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Campaign/Email/ApprovePopup.vue